import { SettingsProfile } from "@widgets/profile";
import { FC } from "react";

export const ProfilePage: FC = () => {
  return <SettingsProfile />;
};
